/**
 * applicator-entry.v1 cizici — UYGULAYICININ EKRANA YAZDIGI, otomatik sayilan soru.
 *
 * "EKRANI ÇOCUĞA GÖSTERMEYİN": uygulayici her bolumu uygular (ör. "aklina gelen
 * 5 hayvan adi soyle", 10 sn), cocugun soyledigi kelimeleri ilgili alana YAZAR;
 * mekanik kelimeleri sayar (max ile sinirli) ve toplami cikarir.
 *
 * Icerik: { applicator?, prompt?, sections:[{id,label,note?,max?}], totalLabel? }
 * Cevap: onAnswerChange({ entries:{id:text}, counts:{id:N}, total }); her zaman
 *   yanitlanabilir (uygulayici bosu da kaydedebilir; ileri acik).
 */
import { useEffect, useRef, useState } from "react";
import type { MechanicProps } from "./types";

interface ESection {
  id: string;
  label: string;
  note?: string;
  max?: number;
}
interface EContent {
  applicator?: { warning?: string; text?: string };
  prompt?: { text?: string };
  sections?: ESection[];
  totalLabel?: string;
}

function countWords(s: string): number {
  return s
    .split(/[\s,;\n]+/)
    .map((t) => t.trim())
    .filter(Boolean).length;
}

export function ApplicatorEntryItem({ item, onAnswerChange }: MechanicProps) {
  const c = item.content as unknown as EContent;
  const sections = c.sections ?? [];
  const saved = item.answer?.entries as Record<string, string> | undefined;
  const [entries, setEntries] = useState<Record<string, string>>(saved ?? {});

  const counts: Record<string, number> = {};
  let total = 0;
  sections.forEach((s) => {
    const n = Math.min(countWords(entries[s.id] ?? ""), s.max ?? 5);
    counts[s.id] = n;
    total += n;
  });
  const maxTotal = sections.reduce((a, s) => a + (s.max ?? 5), 0);

  const cb = useRef(onAnswerChange);
  cb.current = onAnswerChange;
  useEffect(() => {
    cb.current({ entries, counts, total });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entries]);

  return (
    <div className="mech entry-mech">
      {c.applicator?.warning && <p className="applicator-warning">{c.applicator.warning}</p>}
      {c.prompt?.text && <h2 className="prompt tally-title">{c.prompt.text}</h2>}
      {c.applicator?.text && (
        <div className="applicator-card">
          <div className="applicator-label">Uygulayıcı yönergesi</div>
          <p className="applicator-text small">{c.applicator.text}</p>
        </div>
      )}

      <div className="entry-grid">
        {sections.map((s, i) => (
          <div className="entry-cell" key={s.id}>
            <div className="entry-label">
              {i + 1}. {s.label}
            </div>
            {s.note && <div className="entry-note">{s.note}</div>}
            <textarea
              className="entry-input"
              rows={2}
              placeholder="Çocuğun söylediği kelimeleri yaz…"
              value={entries[s.id] ?? ""}
              onChange={(e) =>
                setEntries((p) => ({ ...p, [s.id]: e.target.value }))
              }
            />
            <div className="entry-count">
              Söylenilenlerin sayısı: <b>{counts[s.id]}</b> / {s.max ?? 5}
            </div>
          </div>
        ))}
      </div>

      <div className="entry-total">
        {c.totalLabel ?? "Toplam söylenilenlerin sayısı:"} <b>{total}</b> / {maxTotal}
      </div>
    </div>
  );
}
